// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Right_style_wrapper__32so9","header":"Right_style_header__33BFx","common":"Right_style_common__DaOOn","active":"Right_style_active__1E98o"};